import { ITransferCollegesDatasource } from './../datasources/transfer_colleges_datasource';
import { College } from './../builders/college_builder';
import { CollegeQueryResults } from '../builders/college_query_results_builder';
import { ICommand, IDefineCommand, IQueryMediator } from 'core-ts-types';
import { TransferTransactionModel } from '../models/transfer_transaction_model';

angular.module('capability-ng-transfer').factory(
  'searchTransferCollegesCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferCollegesDatasource: ITransferCollegesDatasource,
    ngTransferCollegeTransactionModel: TransferTransactionModel,
    ngCollegeQueryResultsBuilder: typeof CollegeQueryResults,
    $http: ng.IHttpService
  ): ICommand => {
    return defineCommand('searchTransferCollegesCommand', function searchTransferColleges(
      deferred: ng.IDeferred<CollegeQueryResults>,
      queryText: string = '',
      excludeSelectedColleges: boolean = true
    ): void {
      const selectedCollegeIds = _.map(ngTransferCollegesDatasource.read(), (college) => college.id);
      const inProgressIds = Array.from(ngTransferCollegeTransactionModel.ids);
      const excludedIds = excludeSelectedColleges
        ? _.uniq(selectedCollegeIds.concat(inProgressIds)).map((id) => Number(id))
        : [];

      $http({
        method: 'GET',
        url: 'catalog/college/',
        params: {
          q: queryText,
          limit: 20
        }
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          const foundColleges = {
            colleges: _.reject(response.data.results, (college: College) => excludedIds.includes(college.id)),
            has_more: response.data.next !== null
          };
          deferred.resolve(ngCollegeQueryResultsBuilder.build(foundColleges));
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/search_transfer_colleges_command.ts